import { Amplify } from "aws-amplify";
import { AppConfig } from "@facade/config";

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: AppConfig.cognitoUserPoolId,
      userPoolClientId: AppConfig.cognitoClientId,
    },
  },
});
